// Implementation by
// https://github.com/nuxodin/lazyfill/blob/main/polyfills/Element/prototype/scrollIntoViewIfNeeded.js
const scrollIntoViewIfNeeded = (target, centerIfNeeded = false) => {
  new IntersectionObserver(function callback([entry]) {
    const ratio = entry.intersectionRatio;
    if (ratio < 1) {
      const place = ratio <= 0 && centerIfNeeded ? 'center' : 'nearest';
      target.scrollIntoView({
        block: place,
        inline: place
      });
    }
    this.disconnect();
  }).observe(target);
};

export { scrollIntoViewIfNeeded };
